import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LocalRepoListComponent } from './components/local-repo-list/local-repo-list.component';
import { UserRoleNames } from '../../core/models/users';
import { RouteGuard } from '../../core/route-guards/route-guard.guard';

const routes: Routes = [
  {
    path: 'Repo',
    component: LocalRepoListComponent,
    canActivate: [RouteGuard],
    canActivateChild: [RouteGuard],
    data: { role: [UserRoleNames.GlobalAdmin, UserRoleNames.PowerUser, UserRoleNames.DeploymentAdmin] },
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})


export class LocalRepoRoutingModule { }
